import type { LocationQueryRaw, RouteLocation, RouteLocationRaw, Router } from "vue-router";

import RouteHelper from "@/common/route-helper";
import {
  QUERY_ARTICLE_TAB_COMBINATIONS_VAL,
  QUERY_ARTICLE_TAB_DEFINITIONS_VAL,
  QUERY_ARTICLE_TAB_KEY,
  QUERY_ARTICLE_TAB_MEANINGS_VAL,
  QUERY_ARTICLE_TAB_PHRASES_VAL,
  QUERY_ARTICLE_TAB_SYNONYMS_VAL,
  QUERY_ARTICLE_TAB_TRANSLATIONS_VAL
} from "@/router/query-params";
import type { ArticleTab } from "@/types/search";

export const useArticleTabs = (router: Router) => {
  const routeHelper = new RouteHelper(router);

  const changeArticleTab = (
    tab: ArticleTab | undefined,
    query: LocationQueryRaw = {},
    returnQuery = false
  ) => {
    const VALID_TABS = {
      [QUERY_ARTICLE_TAB_TRANSLATIONS_VAL]: QUERY_ARTICLE_TAB_TRANSLATIONS_VAL,
      [QUERY_ARTICLE_TAB_MEANINGS_VAL]: QUERY_ARTICLE_TAB_MEANINGS_VAL,
      [QUERY_ARTICLE_TAB_COMBINATIONS_VAL]: QUERY_ARTICLE_TAB_COMBINATIONS_VAL,
      [QUERY_ARTICLE_TAB_PHRASES_VAL]: QUERY_ARTICLE_TAB_PHRASES_VAL,
      [QUERY_ARTICLE_TAB_SYNONYMS_VAL]: QUERY_ARTICLE_TAB_SYNONYMS_VAL,
      [QUERY_ARTICLE_TAB_DEFINITIONS_VAL]: QUERY_ARTICLE_TAB_DEFINITIONS_VAL
    };

    const nextQuery = routeHelper.getQueryParams({
      ...query,
      [QUERY_ARTICLE_TAB_KEY]: tab !== undefined ? VALID_TABS[tab] : undefined
    });

    if (returnQuery) {
      return nextQuery;
    }

    const newRoute: RouteLocationRaw = {
      ...router.currentRoute,
      query: nextQuery
    };

    if (!routeHelper.isCurrentRoute(newRoute)) {
      return router.push(newRoute);
    }

    return undefined;
  };

  const articleTabRoute = (tab?: ArticleTab): RouteLocation => {
    const nextQuery = routeHelper.getQueryParams({
      [QUERY_ARTICLE_TAB_KEY]: tab
    });

    return router.resolve({
      ...router.currentRoute,
      query: nextQuery
    });
  };

  return {
    changeArticleTab,
    articleTabRoute
  };
};
